export default __webpack_public_path__ + "91e45fa42143a157ce2be36b83482ec9.png";